export default __webpack_public_path__ + "video/site_video-7c396c8.mp4";